export const ADVANCED_LEFT_MENU_SHOW_EVENTS_BUTTON_ID =
  'advancedLeftMenuShowEventsButton';
export const ADVANCED_SPORT_BY_COMPETITIONS_LAYOUT_SHOW_EVENTS_BUTTON_ID =
  'advancedSportByCompetitionsShowEvents';
export const ADVANCED_LEFT_MENU_DATA_REDUX_KEY = 'advancedAllSports';
export const ADVANCED_EVENTS_DEFAULT_COUNT = 3;
